import React from 'react';
import Icon from '../../../icon';
import Flag from '../../../flag';
import IconButton from '../../../icon-button';
import Mark from '../../../mark';
import keyNames from '../../../../constants/key-names';
import noop from '../../../../../utils/noop';

const TreeSelectItemContent = ({
  isExpandable = false,
  isExpanded = false,
  isSelected = false,
  label,
  icon = undefined,
  flag = undefined,
  disabled = false,
  onExpandToggle = noop,
}) => {
  if (isExpandable) {
    const handleClickExpand = (e) => {
      e.preventDefault();
      e.stopPropagation();
      onExpandToggle();
    };

    const handleKeyDownExpand = (e) => {
      if (e.key === keyNames.ENTER || e.key === keyNames.SPACE) {
        e.preventDefault();
        e.stopPropagation();
        onExpandToggle();
      }
    };

    return (
      <span className="ws-ui-tree-select-item-content">
        <IconButton
          glyph={isExpanded ? 'down' : 'small-right-arrow'}
          size="small"
          disabled={disabled}
          onClick={handleClickExpand}
          onKeyDown={handleKeyDownExpand}
        />
        <span className="ws-ui-tree-select-item-content__label">
          <Mark {...(isSelected && { appearance: 'accent' })}>{label}</Mark>
        </span>
      </span>
    );
  }

  return (
    <span className="ws-ui-tree-select-item-content">
      {!!icon?.glyph && (
        <span className="ws-ui-tree-select-item-content__icon">
          <Icon {...icon} />
        </span>
      )}
      {!!flag?.code && !icon?.glyph && (
        <span className="ws-ui-tree-select-item-content__flag">
          <Flag {...flag} />
        </span>
      )}
      <Mark {...(isSelected && { appearance: 'accent' })}>{label}</Mark>
    </span>
  );
};

export default TreeSelectItemContent;
